import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import {
	SignaturesOfPetitionSunrise,
	type SignaturesOfPetitionSunriseQuery,
	type SignaturesOfPetitionSunriseQueryVariables,
} from './useFetchSignatures.graphql';

export const fetchSignatures = async ({
	petitionId,
	utilityContext: {
		gql: { fetch },
	},
}: {
	petitionId: string;
	utilityContext: UtilityContext;
}) => {
	try {
		const { data } = await fetch<SignaturesOfPetitionSunriseQuery, SignaturesOfPetitionSunriseQueryVariables>({
			query: SignaturesOfPetitionSunrise,
			variables: {
				petitionId,
			},
			rejectOnError: true,
			batched: false,
		});

		if (!data.signaturesDistribution.items.length) {
			throw new Error();
		}

		const { items: signaturesWithPosition } = data.signaturesDistribution;

		return { distribution: signaturesWithPosition };
	} catch {
		return null;
	}
};
